"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedOffer = exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pfComponentLibrary = require("@pf-loan-funnel/pf-component-library");
var _reactComponents = require("@ui-propulsion/react-components");
var _selectPlanForm = _interopRequireDefault(require("./select-plan-form"));
var _useSelectPlan2 = _interopRequireWildcard(require("./use-select-plan"));
var _constants = require("./constants");
require("./styles.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/no-unresolved */

var getSelectedOffer = exports.getSelectedOffer = function getSelectedOffer(application) {
  var hasSelectedOffer = !!(application !== null && application !== void 0 && application.selectedOfferId);

  /*
    For the radio button's value, we use this format: `${application.productType}-${application.selectedOfferId}`. 
    For ADS NI (productID === "NI"), productType is "IF".
    For the rest (ADSPRP, LCTNI, LCFRP), product ID matches with product type.
    Hence, we have to update this only for productType === IF so that the correct radio button
    will be initially selected if it's ADS NI.
  */
  var productType = (application === null || application === void 0 ? void 0 : application.productType) === 'IF' ? _constants.productTypes.NI : application === null || application === void 0 ? void 0 : application.productType;
  return hasSelectedOffer ? "".concat(productType, "-").concat(application === null || application === void 0 ? void 0 : application.selectedOfferId) : '';
};
var SelectPlan = function SelectPlan(_ref) {
  var showBadge = _ref.showBadge,
    application = _ref.application,
    offers = _ref.offers,
    offerProductsForTracking = _ref.offerProductsForTracking,
    disclosures = _ref.disclosures,
    completeLoanProcess = _ref.completeLoanProcess,
    applicationID = _ref.applicationID,
    clientID = _ref.clientID,
    postSelectedOfferURL = _ref.postSelectedOfferURL,
    printPage = _ref.printPage,
    successCallback = _ref.successCallback,
    badges = _ref.badges,
    user = _ref.user;
  var _useSelectPlan = (0, _useSelectPlan2.default)(applicationID, clientID, postSelectedOfferURL, successCallback),
    status = _useSelectPlan.status,
    submitForm = _useSelectPlan.submitForm,
    getVariation = _useSelectPlan.getVariation;
  var selectedOffer = getSelectedOffer(application);
  var expiryDate = application.expiryDate,
    noOfDaysToExpiry = application.noOfDaysToExpiry;
  var redirectUser = function redirectUser() {
    var redirectUrl = "/patientsolutions/".concat(user.isProvider ? 'dashboard' : 'landing?redirectTo=patient_center');
    window.location.assign(redirectUrl);
  };
  var variation = getVariation(offers, completeLoanProcess);
  var frozenDescription = offers.frozenFlag && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "For more information, contact us at", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:solutions@lendingclub.com"
  }, "solutions@lendingclub.com"), ' ', "or (800) 630-1663.");
  var hardPullCounterSubtitle = variation === 'ADS_HARD_PULL_COUNTER' && "".concat(_constants.headers[variation].subtitle + offers.counterADSAmount, ".");
  var header = _constants.headers[variation];
  var isDecline = !completeLoanProcess && offers.offerDeclined && "Unfortunately, you do not prequalify for plan options offered by ".concat(offers.isLCBDeclined ? 'LendingClub' : 'Comenity Capital', " Bank. We\u2019ll send you more details in the mail.");
  return /*#__PURE__*/_react.default.createElement(_reactComponents.App, null, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Spinner, {
    show: status === _constants.AjaxStatus.InProgress
  }), /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.PageTitle, {
    title: header.title,
    subtitle: hardPullCounterSubtitle || header.subtitle,
    description: frozenDescription || header.description,
    cta: {
      text: offers !== null && offers !== void 0 && offers.products.length ? 'Print' : '',
      onClick: printPage,
      id: 'print-offer'
    }
  }), offers !== null && offers !== void 0 && offers.products.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_selectPlanForm.default, {
    defaultValues: {
      selectedOffer: selectedOffer
    },
    products: (0, _useSelectPlan2.extractProducts)(offers.products, showBadge, expiryDate, noOfDaysToExpiry),
    onSubmit: function onSubmit(_ref2) {
      var id = _ref2.selectedOffer;
      return submitForm(id, offerProductsForTracking, variation, badges);
    }
  }), isDecline && /*#__PURE__*/_react.default.createElement(_reactComponents.Card, {
    className: "note-card"
  }, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Text, null, isDecline)), /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Disclosures, {
    disclosuresContent: [{
      heading: 'APR: ',
      description: 'Annual Percentage Rate',
      superscript: '**'
    }].concat((0, _toConsumableArray2.default)((0, _useSelectPlan2.extractDisclosures)(disclosures)))
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "cta-patient-center"
  }, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Button.Primary, {
    onClick: redirectUser,
    type: "button"
  }, "Continue")));
};
SelectPlan.defaultProps = {
  offerProductsForTracking: [],
  badges: null
};
SelectPlan.propTypes = {
  showBadge: _propTypes.default.bool.isRequired,
  application: _propTypes.default.shape({
    selectedOfferId: _propTypes.default.string,
    productType: _propTypes.default.string,
    expiryDate: _propTypes.default.string,
    noOfDaysToExpiry: _propTypes.default.number
  }).isRequired,
  offers: _propTypes.default.objectOf(_propTypes.default.any).isRequired,
  offerProductsForTracking: _propTypes.default.arrayOf(_propTypes.default.string),
  disclosures: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  completeLoanProcess: _propTypes.default.bool.isRequired,
  applicationID: _propTypes.default.string.isRequired,
  clientID: _propTypes.default.string.isRequired,
  postSelectedOfferURL: _propTypes.default.string.isRequired,
  printPage: _propTypes.default.func.isRequired,
  successCallback: _propTypes.default.func.isRequired,
  // We can remove this badges once we are done with the badges experiment
  badges: _propTypes.default.shape({
    lowestBothID: _propTypes.default.string,
    lowestPaymentID: _propTypes.default.string,
    lowestRateID: _propTypes.default.string
  }),
  user: _propTypes.default.shape({
    homePageUrl: _propTypes.default.string,
    isProvider: _propTypes.default.bool
  }).isRequired
};
var _default = exports.default = SelectPlan;
